import BannerContainer from "common/core-ui/BannerContainer.tsx";
import SocialChatLine from "../../../../common/icons/SocialChatLine.tsx";
import styles from "./VirtualStoreSystemMessage.module.scss";
import useVirtualStoreServiceAnnouncement, {
  getServiceAnnouncementDateWithTimeZone,
} from "../../common/virtual-store/useVirtualStoreServiceAnnouncement.ts";
import { useBrandLoaderData } from "../../../root/rootLoader.ts";
import { FormattedDate, useIntl } from "react-intl";
import { VerticalBarLiteral } from "../../../../common/core-ui/VerticalBarLiteral.tsx";
import BaseLinkOrButton from "../../../../common/core-ui/BaseLinkOrButton.tsx";
import MiscellaneousXMedium from "../../../../common/icons/MiscellaneousXMedium.tsx";
import { clsx } from "clsx";
import ServiceAnnouncementBannerBody from "../../common/virtual-store/ServiceAnnouncementBannerBody.tsx";

/**
 * @see ServiceAnnouncementBanner
 */
export default function VirtualStoreSystemMessage() {
  const brand = useBrandLoaderData();
  const intl = useIntl();
  const [shouldShow, onDismiss] = useVirtualStoreServiceAnnouncement();

  if (!shouldShow) {
    return null;
  }

  return (
    <BannerContainer icon={<SocialChatLine />} className={styles.banner}>
      <div className={styles.mainContent}>
        <div>
          <h2>
            <span className={styles.title}>
              {brand.VirtualStore.ServiceAnnouncement.title}
            </span>
            <VerticalBarLiteral />
            <FormattedDate
              dateStyle="long"
              value={getServiceAnnouncementDateWithTimeZone(
                brand.VirtualStore.ServiceAnnouncement.startDate!
              )}
            />
          </h2>
          <ServiceAnnouncementBannerBody
            body={brand.VirtualStore.ServiceAnnouncement.body}
          />
        </div>
        <BaseLinkOrButton
          className={clsx(
            "vst-icon-button-circle",
            "vst-icon-button-variant-black",
            // Not a compact space but the hover color is disabled and that makes the scaling look bad
            "vst-icon-button-option-compact",
            styles.closeButton
          )}
          aria-label={intl.formatMessage({ defaultMessage: "Close" })}
          data-tooltip-content={intl.formatMessage({
            defaultMessage: "Close",
          })}
          onClick={onDismiss}
        >
          <MiscellaneousXMedium />
        </BaseLinkOrButton>
      </div>
    </BannerContainer>
  );
}
